import React from 'react';
// Modules
import {
  Box,
  Button,
  Container,
  Divider,
  FormControl,
  FormHelperText,
  FormLabel,
  Heading,
  HStack,
  Input,
  Text,
  VStack,
} from '@chakra-ui/react';
import Link from 'next/link';
import { NextPage } from 'next/types';
// Components
import Page from '../components/layout/Page';
// Hooks
import useAuthForm from '../hooks/useAuthForm';
// Utils
import routes from '../utils/routes';

const LogInPage: NextPage = () => {
  const {
    code,
    confirmationResult,
    displayPasswordInput,
    isEmailValid,
    isLoading,
    isPhoneValid,
    onClickContinue,
    onClickFacebook,
    onClickGoogle,
    onClickLogIn,
    password,
    setCode,
    setPassword,
    setUsername,
    username,
  } = useAuthForm();

  function onKeyDownContinue(event: React.KeyboardEvent<HTMLInputElement>) {
    if (event.key === 'Enter' && !isLoading && (isEmailValid || isPhoneValid)) {
      event.preventDefault();

      onClickContinue();
    }
  }

  function onKeyDownSubmit(event: React.KeyboardEvent<HTMLInputElement>) {
    if (event.key === 'Enter' && !isLoading) {
      event.preventDefault();

      onClickLogIn();
    }
  }

  return (
    <Page>
      <Container maxW="40ch" py="16">
        <VStack alignItems="stretch" spacing="8">
          <VStack alignItems="stretch">
            <Heading as="h1" size="lg">
              Masuk
            </Heading>
            <Box bgColor="primary.500" h="4px" w="64px" />
          </VStack>
          <VStack alignItems="stretch" spacing="4">
            {confirmationResult ? (
              <FormControl id="code">
                <FormLabel>Kode verifikasi</FormLabel>
                <Input
                  autoComplete="one-time-code"
                  onChange={(e) => setCode(e.target.value)}
                  onKeyDown={onKeyDownSubmit}
                  value={code}
                />
              </FormControl>
            ) : (
              <FormControl id="username" isDisabled={displayPasswordInput}>
                <FormLabel>Nomor HP atau alamat email</FormLabel>
                <Input
                  autoComplete="username"
                  onChange={(e) => setUsername(e.target.value)}
                  onKeyDown={onKeyDownContinue}
                  value={username}
                />
                <FormHelperText>Contoh: email@utamastationery.com</FormHelperText>
              </FormControl>
            )}
            {displayPasswordInput && (
              <FormControl id="password">
                <FormLabel>Kata sandi</FormLabel>
                <Input
                  autoComplete="current-password"
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyDown={onKeyDownSubmit}
                  type="password"
                  value={password}
                />
              </FormControl>
            )}
          </VStack>
          <VStack alignItems="stretch" spacing="4">
            {displayPasswordInput && (
              <Box display="flex" justifyContent="flex-end">
                <Link href={routes.forgotPassword.href} passHref>
                  <Text as="a" color="secondary.500">
                    Lupa kata sandi?
                  </Text>
                </Link>
              </Box>
            )}
            {confirmationResult || displayPasswordInput ? (
              <Button
                colorScheme="primary"
                isLoading={isLoading}
                onClick={onClickLogIn}
                textColor="black"
              >
                Masuk
              </Button>
            ) : (
              <Button
                colorScheme="primary"
                id="btn-continue"
                isDisabled={!isEmailValid && !isPhoneValid}
                isLoading={isLoading}
                onClick={onClickContinue}
                textColor="black"
              >
                Selanjutnya
              </Button>
            )}
          </VStack>
          <HStack>
            <Divider />
            <Text color="gray.500" fontSize="sm" minW="128px" textAlign="center">
              atau masuk dengan
            </Text>
            <Divider />
          </HStack>
          <HStack spacing="4">
            <Button
              flex={1}
              leftIcon={<img className="social-icon" alt="Facebook" src="/images/icon-facebook.svg" />}
              onClick={onClickFacebook}
              variant="outline"
            >
              Facebook
            </Button>
            <Button
              flex={1}
              leftIcon={<img className="social-icon" alt="Google" src="/images/icon-google.svg" />}
              onClick={onClickGoogle}
              variant="outline"
            >
              Google
            </Button>
          </HStack>
          <Text color="gray.500" textAlign="center">
            {'Belum punya akun Utama? '}
            <Link href={routes.signUp.href} passHref>
              <Text as="a" textColor="secondary.500">
                Daftar
              </Text>
            </Link>
          </Text>
        </VStack>
      </Container>
      <style jsx>
        {`
          .social-icon {
            height: 18px;
            width: 18px;
          }
        `}
      </style>
    </Page>
  );
};

export default LogInPage;
